export default {
    SET_SERVICE: (state, payload) => {
        state.service = payload
    },
    SET_SERVICE_FILTROS: (state, payload) => {
        state.serviceFiltros = payload
    },
    SET_SERVICE_MOVIMIENTOS: (state, payload) => {
        state.serviceMovimientos = payload
    },
    SET_SERVICE_MOVIMIENTOS_FILTROS: (state, payload) => {
        state.serviceMovimientosFiltered = payload
    }
  }